import { createStyle } from '@gluestack-style/react';

export const AccordionItem = createStyle({});
